import { type ReactNode } from "react";
import { Badge, Button, IconButton } from "~/common/mui";
import classNames from "classnames";
import { C_ON_SURFACE_VARIANT } from "~/common/components/icon/Colors";
import { TooltipWithArrow } from "~/common/components/TooltipWithArrow";

interface PersonalNavItemProps {
  name: string;
  icon?: ReactNode;
  isActive?: boolean;
  isNotification?: boolean;
  badgeContent?: string | number;
  badgeVariant?: "default" | "new";
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  "data-test-id"?: string;
  label?: string | null;
  "data-ta-spec"?: string;
  "data-ta-total"?: number | null;
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const PersonalNavItem = (props: PersonalNavItemProps) => (
  <div
    onClick={props.onClick}
    data-test-id={props["data-test-id"]}
    className={classNames(
      "scha__personal-nav-item",
      !props.isNotification && {
        "scha__personal-nav-item--active": props.isActive,
      },
    )}
  >
    <div className={"scha__personal-nav-item__details" + (props.isNotification ? "__notification" : "")}>
      <TooltipWithArrow placement="top" title={props.name ? props.name : ""}>
        <Badge badgeContent={props.badgeContent ? props.badgeContent : null}>
          {props.label && (
            <Button
              variant="text"
              color="textPrimary"
              startIcon={props.icon}
              data-ta-spec={props["data-ta-spec"]}
              data-ta-total={props["data-ta-total"]}
            >
              {props.label}
            </Button>
          )}
          {props.icon && !props.label && (
            <IconButton
              sx={{ color: C_ON_SURFACE_VARIANT }}
              data-ta-spec={props["data-ta-spec"]}
              data-ta-total={props["data-ta-total"]}
              onMouseEnter={props.onMouseEnter}
              onMouseLeave={props.onMouseLeave}
            >
              {props.icon}
            </IconButton>
          )}
        </Badge>
      </TooltipWithArrow>
    </div>
  </div>
);
